import type { ReduxAction } from 'app/redux/types';

import type { SupportedLang } from '../constants';

// --

export const NOTIFY_ABOUT_CHANGED_LANG = 'I18N:NOTIFY_ABOUT_CHANGED_LANG';

export type NotifyAboutChangedLang = ReduxAction<typeof NOTIFY_ABOUT_CHANGED_LANG, {
  language: SupportedLang;
}>;

export const notifyReduxAboutChangedLang = (language: SupportedLang) => ({
  type: NOTIFY_ABOUT_CHANGED_LANG,
  payload: { language },
});
